import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { DatePipe } from '@angular/common';
import { Organization } from '../../../common/model/Organization';
import { TransferConsigmentFacade } from '../../../common/facade/TransferConsigmentFacade';
import { TransferConsigmentDto } from '../../../common/model/dto/TransferConsigmentDto';
import { Router } from '@angular/router';


@Component({
  selector: 'app-tranfer-consignment',
  templateUrl: './tranfer-consignment.component.html',
  styleUrls: ['./tranfer-consignment.component.css']
})
export class TranferConsignmentComponent implements OnInit {
  titleConsigment = res.Consigment;
  lblDownload = res.Download;
  lblOriginStore = res.OriginStore;
  lblDestinationStore = res.DestinationStore;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblTransferReference = res.TransferReference;
  lblQuantity = res.Quantity;
  lblEntry = res.Entry;
  lblDateTransfer=res.DateTransfer;
  lblStatus=res.Status;
  lblDateTransite=res.DateTransite;
  lblAllStores=res.AllStores;
  lblOrganization = res.Organization;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  errorSmallerThan = res.SmallerDateThan;
  errorGreaterThan = res.GreaterDateThan;
  res = res;
  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  //selectedOrganizations: Organization[] = [];
  public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
                        this.getNowUTC().getMonth(),
                        1 ,
                        this.getNowUTC().getHours(),
                        this.getNowUTC().getMinutes(),
                        this.getNowUTC().getSeconds(),
                        this.getNowUTC().getMilliseconds());
  public txtMaxDate = this.getNowUTC();
  txtStartDate = new Date();
  txtEndDate = new Date();
  strOrganizationSelected: string;
  tenantId: number;

  

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }
  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // filters
  storeOriginId = -1;
  storesOrigin = [];
  storeDestinyId = -1;
  storesDestiny = [];

  public organizationList: Organization[] = [];
  public AvailableOrganizations: Organization[] = [];
  public selectedOrganization: Organization[]=[];
    public TenantId = 0;
    public stores = [];
  //permissions
  permissionsList: any[] = []
  visibleAdd = false
  visibleEdit = false
  rows: any[] = [];
  private _filteredData: TransferConsigmentDto[] = [];

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _router: Router,
    private _datePipe: DatePipe,
    private _transferConsigmentFacade: TransferConsigmentFacade,
    private _facadeStore: StoreFacade,
    public strings: Strings,
    public datepipe: DatePipe,
  ) { 
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit(): void {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.TenantId = this.strings.getTenant();
    this.AvailableOrganizations = this.strings.getAvailableOrganizations();
    this.organizationList = this.AvailableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }
    
   
  }
  
  //Get Stores 
  private getStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);

    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        const lstStores = response.data.filter(org => this.strOrganizationSelected.includes(org.organizationId));
        this.storesOrigin=lstStores;
        this.storesDestiny=lstStores;

      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger');
      }
    );
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }
 
  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }
  // filter Transfer
  onStoreOriginChange() {
    this.storeDestinyId = -1;
    if (this.storeOriginId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.storeOriginId.toString() === this.storeOriginId.toString());
      });
    }
  }

  onStoreDestinyChange() {
    this.storeOriginId = -1;
    
    if (this.storeDestinyId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.storeDestinationId.toString() === this.storeDestinyId.toString());
      });
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }
  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        let info:any
        if(this.isSpanish){
          info= {
            [this.strings.GetText(res.DateTransfer)]: this._datePipe.transform(row.transferDate, 'dd/MM/yyyy'),
            [this.strings.GetText(res.TransferReference)]:row.transferStoreId,
            [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
            [this.strings.GetText(res.DestinationStore)]: row.storeDestinationName,
            [this.strings.GetText(res.Quantity)]: row.quantity,
            [this.strings.GetText(res.DateTransite)]:row.daysInTransite,
            [this.strings.GetText(res.Status)]: row.status
          };
        } 
        else
        {
          info= {
            [this.strings.GetText(res.DateTransfer)]: this._datePipe.transform(row.transferDate, 'MM/dd/yyyy'),
            [this.strings.GetText(res.TransferReference)]:row.transferStoreId,
            [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
            [this.strings.GetText(res.DestinationStore)]: row.storeDestinationName,
            [this.strings.GetText(res.Quantity)]: row.quantity,
            [this.strings.GetText(res.DateTransite)]:row.daysInTransite,
            [this.strings.GetText(res.Status)]: row.status
          };
        }
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.Consigment));
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }
  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  getTransferConsignmentByStore() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingTransfersInTransit);
 
    this._transferConsigmentFacade.GetCollectionConsigmentByStore(
        this.storeOriginId
        , this.storeDestinyId
            , this.strOrganizationSelected).subscribe(
        response => {
            this.rows = response.data;
            this._filteredData = response.data;
            this.loading = false;
        }, error => {
            this.loading = false;
            this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTransfersCouldNotBeObtained), 'danger');
        }
    );
    
  }

  search() {
      this.getTransferConsignmentByStore();
  }

  onChangeStartDate(value) {
    this.txtStartDate = value;    
  }

  onChangeEndDate(value) {
    this.txtEndDate = value;
    this.txtMaxDate = value;
    }
    onChangeOrganization(selectedOrganization: any[]) {

        this.selectedOrganization = selectedOrganization;
        this.strOrganizationSelected = this.selectedOrganization.map(e => e.organizationId).join(',');
        this.getStores()
    }
}
